module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("An Introduction to the Scriptures of Israel: History and Theology")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb1"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "tab",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("COS")])]), _vm._v(" "), _c('td', {
    staticClass: "abb1"
  }, [_c('i', [_vm._v("The Context of Scripture.")]), _vm._v(" Edited by William W. Hallo and K. Lawson Younger Jr. 4 vols. Leiden: Brill, 1997–2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb"
  }, [_vm._v("NJPS")]), _vm._v(" "), _c('td', {
    staticClass: "abb1"
  }, [_vm._v("New Jewish Publication Society Version ("), _c('i', [_vm._v("Tanakh")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb"
  }, [_vm._v("NRSV")]), _vm._v(" "), _c('td', {
    staticClass: "abb1"
  }, [_vm._v("New Revised Standard Version")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847bb512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 69
// module chunks = 0